export default {
  cloudFortified: {
    faq: 'https://www.atlassian.com/trust/marketplace',
    supportRequirements: 'https://developer.atlassian.com/platform/marketplace/cloud-fortified-apps-program-support-requirements'
  },
  bugBountyProgramDetails: 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program'
};